// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2UvBc","title":"Info_title__2epsz","selects":"Info_selects__38fN6","requiredAsterisk":"Info_requiredAsterisk__2Tz9_"};